export default "/assets/images/CC-product-showcase-small-01.361357e5c6d1d23d.jpg";